/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund200,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund.ts";

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams>;

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParamsSchema =
  z
    .object({
      refundValue: z.optional(z.coerce.number()),
      refundReason: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund200Schema =
  z.boolean() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500>;

export const patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponseSchema =
  z.lazy(
    () => patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund200Schema,
  ) as unknown as ToZod<PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse>;
